<template>
  <div>
    <page-header title="品牌设置" description="维护自动舆情采集使用的品牌、产品和风险词">
      <el-button :loading="starting" @click="start">保存后立即采集</el-button>
      <el-button type="primary" @click="open(null)">新增词条</el-button>
    </page-header>
    <el-card v-loading="loading">
      <div class="stats">
        <span>品牌词 <b>{{ brandCount }}</b></span>
        <span>产品/SKU <b>{{ skuCount }}</b></span>
        <span>风险词 <b>{{ abnormalCount }}</b></span>
        <span>参与自动采集 <b>{{ searchCount }}</b></span>
      </div>
      <el-table :data="items">
        <el-table-column prop="term_type" label="类型" />
        <el-table-column prop="term" label="词条" />
        <el-table-column prop="category" label="分类" />
        <el-table-column prop="risk_level" label="风险等级" />
        <el-table-column label="自动采集">
          <template slot-scope="scope">
            <el-tag :type="scope.row.search_enabled ? 'success' : 'info'">
              {{ scope.row.search_enabled ? '参与搜索' : '仅分析' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="检索平台" min-width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.platforms && scope.row.platforms.length">{{ platformNames(scope.row.platforms) }}</span>
            <span v-else class="muted">未配置</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="open(scope.row)">编辑</el-button>
            <el-button type="text" class="delete-button" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <term-dialog :visible.sync="dialog" :item="editing" @success="load" />
  </div>
</template>

<script>
import { yuqingApi } from '@/api/yuqing'
import PageHeader from '../components/PageHeader.vue'
import TermDialog from './TermDialog.vue'

export default {
  components: { PageHeader, TermDialog },
  data() {
    return { items: [], loading: false, dialog: false, editing: null, starting: false }
  },
  computed: {
    brandCount() { return this.items.filter(item => item.term_type === 'brand').length },
    skuCount() { return this.items.filter(item => item.term_type === 'sku').length },
    abnormalCount() { return this.items.filter(item => item.term_type === 'abnormal').length },
    searchCount() { return this.items.filter(item => item.active && item.search_enabled).length }
  },
  mounted() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        this.items = (await yuqingApi.get('lexicon?page=1&page_size=200')).terms || []
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.loading = false
      }
    },
    open(item) {
      this.editing = item
      this.dialog = true
    },
    platformNames(values) {
      const names = { xiaohongshu: '小红书', weibo: '微博', douyin: '抖音', bilibili: 'B站', kuaishou: '快手' }
      return (values || []).map(value => names[value] || value).join('、')
    },
    async remove(item) {
      try {
        await this.$confirm(`确定删除词条“${item.term}”吗？删除后无法恢复。`, '删除词条', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await yuqingApi.delete(`lexicon/${item.id}`)
        this.$message.success('词条已删除')
        await this.load()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') this.$message.error(error.message || '删除失败')
      }
    },
    async start() {
      this.starting = true
      try {
        await yuqingApi.post('public-opinion/refresh', {})
        this.$message.success('已按当前词条启动舆情采集')
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.starting = false
      }
    }
  }
}
</script>

<style scoped>
.stats { display: flex; gap: 28px; padding: 0 0 18px; color: #606266 }
.stats b { margin-left: 4px; color: #303133; font-size: 20px }
.delete-button { color: #f56c6c }
.muted { color: #909399 }
</style>
